import ContactPhone from '@mui/icons-material/ContactPhone'
import { Container, Modal,Box, Button, Input, Typography, TextField } from '@mui/material'
import React, { useState } from 'react'
import CloseButton from '../../../components/CloseButton'
import ArrowCircleLeftIcon from '@mui/icons-material/ArrowCircleLeft';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import YouTube from 'react-youtube';

const ZoomModal = (props) => {
    const { setZoomModalOpen, zoomModalOpen,
        src, zoomType, vid,handleImgNext,handleImgBack,
        handleVidNext,handleVidBack } = props
    const [ pin, setPin ] = useState()
    const [ actionError, setActionError ] = useState('')
   
  return (
    <>
        <Modal 
            open={zoomModalOpen}
            onClose={()=>setZoomModalOpen(!zoomModalOpen)}
            >
            <Container sx={{zIndex:999}}>
                <Box sx={{ 
                    display:'flex',
                    flexDirection:'column',
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '100%',
                    height:'100%',
                    backgroundColor:'#000',
                    borderRadius:'10px',
                    border:'2px solid #000',
                    fontFamily: 'Gilroy, sans-serif',
                    justifyContent:'center',
                    textAlign:'center',
                    alignItems:'center',
                    gap:'0.5rem',
                    padding:'0.5rem'
                    
                    }}>
                        <Box sx={{position:'absolute', top:'0.5rem', right:'0.5rem',zIndex:9999999}}>
                            <CloseButton func={setZoomModalOpen} val={zoomModalOpen}
                        
                            />
                        </Box>
                        <ArrowCircleLeftIcon sx={{
             fontSize:'4rem',
             cursor:' pointer',
             opacity: 0.5,
             position:'absolute',left:'5%', top:'50%',
             translate:'transform(0,-50%)',
              borderRadius:'100%',
             backgroundColor:'#FFF',
            boxShadow:'0 0 3px rgb( 255, 255, 255,0.5)',
           zIndex:9999999999,
            }}
            onClick={()=>{
                if(zoomType === 'img'){handleImgBack()}
                if(zoomType === 'vid'){handleVidBack()}
            }}
            />
                    {(zoomType === 'img' && src )&& <Box component={'img'}
                        src={src}
                        sx={{
                            width:'100%',maxWidth:'600px', 
                        
                            height:'auto'}}
                        >

                    </Box>}
                      
                    {/* {(zoomType === 'vid' && vid) && <Box component={'iframe'}
                        src={vid?.url}
                        sx={{
                            width:'100%',maxWidth:'600px', 
                        
                            height:'auto'}}
                        >

                    </Box>} */}
                      {(zoomType === 'vid' && vid) &&
                        <YouTube videoId={vid?.platform_id}/>
                      }
                    <ArrowCircleRightIcon sx={{
            fontSize:'4rem',
            cursor:' pointer',
            opacity: 0.5,
            position:'absolute',
            right:'5%', top:'50%',
            translate:'transform(0,-50%)',
            borderRadius:'100%',
            backgroundColor:'#FFF',
            boxShadow:'0 0 3px rgb( 255, 255, 255,0.5)',
           zIndex:9999999999,
           }}
             onClick={()=>{
                if(zoomType === 'img'){handleImgNext()}
                if(zoomType === 'vid'){handleVidNext()}
            }}
           />
                    </Box>
                    
            </Container>
        </Modal>
        
    </>
  )
}

export default ZoomModal